import React from 'react';

const About = () => {
  return (
    <section id="about">
      <h1>About Me</h1>
      <p>
        Hi, I’m Harshita Singh. I don't just write code, I build intelligent digital experiences. 
        With a solid foundation in Data Structures and Algorithms, I bridge the gap between robust 
        Full-Stack development and the evolving world of Artificial Intelligence.
      </p>
      <p>
        From my academic journey at VIT-AP to contributing to the Open Source community, I’ve dedicated 
        myself to mastering tools like React.js, Node.js, and ML frameworks. My goal is always the same: 
        to create software that is not only responsive and attractive but also "smart." I’m always looking 
        for my next challenge. Let’s build something impactful together.
      </p>
    </section>
  );
};

export default About;
